<template>

    <v-dialog persistent v-model="exibir" lazy full-width width="290px">
        <v-text-field v-bind="$attrs" slot="activator" v-model="dataFormatada" append-icon="event" readonly></v-text-field>
        <v-date-picker v-model="data" @change="onChange" scrollable locale="pt-BR" :color="color">
            <v-spacer></v-spacer>
            <v-btn text :color="color" @click="exibir = false">Cancelar</v-btn>
        </v-date-picker>
    </v-dialog>

</template>

<script>

export default {
    name: 'z-date-picker',

    props: {
        value: {
            type: String,
            default: ''
        },
    },

    data() {
        return {
            data: null,
            dataFormatada: null,
            exibir: false
        }
    },

    methods: {
        onChange(data) {
            this.dataFormatada = this.formatarData(data);
            this.exibir = false;
            data = data.replace(/[-/]/g, '-');
            this.$emit('input', data);
        },

        formatarData(data) {
            if (!data) {
                return null;
            }
            data = data.replace(/[-/]/g, '-');
            return  data.split("-").reverse().join('/');
        },
    },

    computed: {
    },

    watch: {
        value(val, oldval) {
            if (val) {
                this.data = val.replace(/[-/]/g, '-');
                this.dataFormatada = this.formatarData(this.data);
            } else {
                this.data = null;
                this.dataFormatada = null;
            }
        }
    }

}

</script>

<style scoped>

</style>
